import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { flightStatusMap } from "../../../pages/Orders/OrdersData";
import { getTestLevel } from "../../../utils/testLevel";
import useFlight from "../../../hooks/useFlight";
import { ActionContext } from "../OrderList";
import { useInsuranceActions } from "../../../hooks/useInsuranceActions";
import { orderIsOnRequest } from "../../../utils/booking/orderInRequest";
import { configurations } from "../../../configurations";
import useAccount from "../../../hooks/useAccount";

export default function FlightMenu({ og, mobile, setFlightInvoice }) {
  const { searchForInsuranceFromFlightBooking } = useInsuranceActions();
  const [openPayment, setOpenPayment] = useState(false);
  const { refreshBooking } = useFlight();
  const bookingData = og?.flightBooking?.at(0);
  const { ticketFilterType } = useSelector((state) => state.order);

  const {checkPermission} = useAccount();

  const voidTime = new Date(bookingData?.voidDeadline || null);
  const ticketTime = new Date(bookingData?.ticketingExpiry || null);

  const navigate = useNavigate();

  if (getTestLevel() < getTestLevel("live")) console.log("og: ", og);

  async function handleRefresh(id, callback) {
    const res = await refreshBooking(id);
    if (res.return) callback && callback();
  }

  const handleSelect = () => {
    navigate("/order/flight/ticket/detail");
  };

  const handleAddInsurance = () => {
    searchForInsuranceFromFlightBooking({ data: og });
  };

  const requestPending = orderIsOnRequest(og);

  return (
    <div
      className={`${
        !mobile ? "absolute right-2 top-full" : ""
      } p-2 flex flex-col z-10 bg-white rounded-md shadow-xl min-w-[200px]`}
      style={{
        boxShadow: "0 5px 15px #999",
      }}
    >
      <ActionContext.Consumer>
        {(value) => {
          const {
            reload,
            setOpenPayment,
            setBooking,
            setOpenCancelOrder,
            setOpenIssueTicket,
            setOpenSendInvoice,
            setOpenRebook,
            setOpenVoidTicket,
            searchHotel,
            searchTour,
          } = value || {};
          // Ticketed:
          // x View order
          // x Add a bag
          // x Change date
          // x Change name
          // Void
          // x Refund (if refundable)

          // Pending Payment:
          // View order
          // Make payment
          // Hold booking
          // Add hotel
          // Add tour
          // Add insurance
          // Add bag
          // Add a seat
          // Cancel order

          // PAID:
          // View order
          // Issue ticket
          // Add hotel
          // Add tour
          // Add insurance
          // Add bag
          // Add a seat
          // Cancel order

          // Cancelled:
          // View order
          // Rebook order

          // Share
          // Share pdf
          // Share via email

          const postTicketing =
            og?.fee !== undefined || og?.ticketNo || og?.changeRequest;

          const navigateTo = (url) => {
            if (postTicketing) navigate(url);
            else window.open(url, "_blank");
          };

          const menus = [
            {
              label:
                ticketFilterType === "Tickets"
                  ? "View"
                  : postTicketing
                  ? "View Request"
                  : "View order",
              action: () => {
                // const priceFreezeStatus =
                //   og?.flightBooking?.at(0)?.priceFreezeStatus;

                const route = "/order/flight/ticket/detail/";
                // const route =
                //   priceFreezeStatus ===
                //     configurations.priceFreezeStatus.initiated.code ||
                //   priceFreezeStatus ===
                //     configurations.priceFreezeStatus.approved.code
                //     ? "/order/flight/ticket/detail/repayment/"
                //     : "/order/flight/ticket/detail/";
                navigateTo(route + og?._id + "?page=" + ticketFilterType);
              },
            },
            {
              label: "Refresh Order Status",
              action: () => handleRefresh(og?.flightObj?._id, reload),
              showFor: ["issued", "Ticket issued", "Awaiting ticketing"],
              hide: postTicketing && ticketFilterType !== "Tickets",
            },
            // {
            //   label: "Send Invoice",
            //   action: () => setOpenSendInvoice(og?.flightObj?._id),
            //   hide: postTicketing && ticketFilterType !== "Tickets",
            // },
            {
              label: "Send Invoice / Reciept",
              action: () => setFlightInvoice(true),
              hide: postTicketing && ticketFilterType !== "Tickets",
            },
          ];

          if (!postTicketing)
            menus?.push(
              ...[
                {
                  label: "Make payment",
                  action: () => {
                    setOpenPayment(og?.flightObj?._id);
                    setBooking({ booking: og });
                  },
                  showFor: ["Not Paid", "booked"],
                  hide: (ticketTime - new Date() <= 0) || !checkPermission('pay:ticket'),
                },
                {
                  label: "Issue Ticket",
                  action: () => setOpenIssueTicket(bookingData),
                  showFor: ["Paid", "issuable"],
                  hide: !checkPermission('issue:ticket')
                },
                // {
                //   label: "Send Invoice",
                //   action: () => setOpenSendInvoice(og?.flightObj?._id),
                // },
                // {
                //   label: "Hold booking",
                //   action: () => {},
                //   showFor: ["Not Paid", "booked"],
                // },
                // {
                //   label: "Add a bag",
                //   action: () => {},
                //   showFor: [
                //     "Not Paid",
                //     "booked",
                //     "Ticket issued",
                //     "issued",
                //     "Paid",
                //     "issuable",
                //   ],
                // },
                // {
                //   label: "Add a seat",
                //   action: () => {},
                //   showFor: [
                //     "Not Paid",
                //     "booked",
                //     "Ticket issued",
                //     "issued",
                //     "Paid",
                //     "issuable",
                //   ],
                // },
                // {
                //   label: "Add hotel",
                //   action: () => {searchHotel(og)},
                //   showFor: ["Not Paid", "booked", "Paid", "issuable"],
                // },
                // {
                //   label: "Add tour",
                //   action: () => {searchTour(og)},
                //   showFor: ["Not Paid", "booked", "Paid", "issuable"],
                // },
                {
                  label: "Add protection",
                  action: () => {
                    handleAddInsurance();
                  },
                  showFor: ["Not Paid", "booked", "Paid", "issuable"],
                },
                {
                  label: "Rebook",
                  action: () => setOpenRebook(og?.flightObj),
                  showFor: ["Expired", "Canceled", "TIcket Canceled"],
                },
                {
                  label: "Change date",
                  action: () =>
                    navigateTo("/order/flight/ticket/changedate/" + og?._id),
                  showFor: ["Ticket issued", "issued"],
                  hide: requestPending,
                },
                {
                  label: "Change name",
                  action: () =>
                    navigateTo("/order/flight/ticket/changeinfo/" + og?._id),
                  showFor: ["Ticket issued", "issued"],
                  hide: requestPending,
                },
                {
                  label: "Refund",
                  action: () =>
                    navigateTo("/order/flight/ticket/refund/" + og?._id),
                  showFor: ["Ticket issued", "issued"],
                  hide: og?.status === "Approved" || requestPending, //bookingData?.isRefundable
                },
                // {
                //   label: "Hold booking",
                //   action: () => {},
                //   showFor: ["Not Paid", "booked"],
                  // hide: !checkPermission('hold:flight-booking')

                // },
                // {
                //   label: "Download pdf",
                //   action: () => {},
                // },
                // {
                //   label: "Share order",
                //   action: () => {},
                // },
                // {
                //   label: "Share pnr",
                //   action: () => {},
                //   hide: !isGDSSupplier(bookingData?.supplier),
                // },
                // {
                //   label: "Issue via intraverse",
                //   action: () => {},
                //   hide: !isGDSSupplier(bookingData?.supplier),
                // },
                {
                  label: "Cancel order",
                  action: () => setOpenCancelOrder(og?.flightObj?._id),
                  showFor: ["Not Paid", "booked", "Paid", "issuable"],
                  hide: !checkPermission('cancel:flight-booking')
                },
                {
                  label: "Void",
                  action: () =>
                    navigateTo("/order/flight/ticket/void/" + og?._id),
                  hide: voidTime - new Date() <= 0 || requestPending,
                  showFor: ["Ticket issued", "issued", "Denied"],
                },
              ]
            );

          let items = menus?.filter((obj) => {
            const bookingData = og?.flightBooking?.at(0);
            const status = flightStatusMap(bookingData?.status);
            console.log(status, obj?.showFor);
            return (
              (obj?.showFor ? obj?.showFor?.includes(status) : true) &&
              !obj?.hide
            );
          });

          return (items || [])?.map((item, index) => (
            <div
              key={index}
              onClick={() => item?.action()}
              className="font-bold text-sm text-[#444] px-2 py-2 hover:bg-[#818083]/10 border-b"
            >
              {item?.label}
            </div>
          ));
        }}
      </ActionContext.Consumer>
    </div>
  );
}
